/* eslint-disable react/prop-types,object-curly-newline,react/react-in-jsx-scope */
import React from 'react';

const adaptFileEventToValue = delegate =>
  e => delegate(e.target.files[0]);

const FileInput = ({
  input: {
    value: omitValue,
    onChange,
    onBlur,
    ...inputProps
  },
  meta: omitMeta,
  ...props
}) =>
  (<input
    onChange={adaptFileEventToValue(onChange)}
    onBlur={adaptFileEventToValue(onBlur)}
    type="file"
    {...inputProps}
    {...props}
  />);

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/Forms/FileInput/FileInput.jsx